
const MnftsSection = () => {
  const nftCollections = [
    {
      name: "Brother Genesis",
      supply: "50",
      features: ["BroCode access and mentorship", "Exclusive governance voting rights", "Priority in job marketplace"],
      image: "/lovable-uploads/a3642997-be68-4ef2-9870-90f587a8ce29.png"
    },
    {
      name: "Alpha Mustaches", 
      supply: "50",
      features: ["Advanced bot features unlock", "IRL Brotherhood events access", "BroCode access and mentorship"],
      image: "/lovable-uploads/7c7fff28-ef19-4c00-a321-44a6cbbf8eea.png"
    },
    {
      name: "BroMentum Legends",
      supply: "50", 
      features: ["Exclusive governance voting rights", "Priority in job marketplace", "Advanced bot features unlock"],
      image: "/lovable-uploads/673b9773-9e54-4919-a741-989092d8994f.png"
    },
    {
      name: "Elite Brotherhood",
      supply: "50",
      features: ["IRL Brotherhood events access", "BroCode access and mentorship", "Exclusive governance voting rights"],
      image: "/lovable-uploads/43933e90-8ad7-4e73-8370-7c9c54c650da.png"
    },
    {
      name: "Sigma Collection",
      supply: "50",
      features: ["Priority in job marketplace", "Advanced bot features unlock", "IRL Brotherhood events access"],
      image: "/lovable-uploads/08a2da8f-d409-489e-81e9-704eca455f80.png"
    }
  ];

  return (
    <section id="nfts" className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            🎨 Cultural Artifacts (MNFTs)
          </h2>
          <p className="text-lg text-muted-foreground max-w-4xl mx-auto mb-4">
            MNFTs are digital collectibles celebrating men in Web3. They're not investments — just cultural artifacts with meme utility.
          </p>
          <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-3 max-w-3xl mx-auto">
            <p className="text-sm text-muted-foreground">
              <strong>Disclaimer:</strong> Owning an MNFT does not confer revenue, access to funding, or financial privileges.
            </p>
          </div>
        </div>
        
        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-6">
          {nftCollections.map((collection, index) => (
            <div key={index} className="bg-card rounded-lg p-6 border border-border">
              <div className="aspect-square rounded-lg mb-6 overflow-hidden bg-muted">
                <img 
                  src={collection.image} 
                  alt={collection.name}
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-xl font-bold text-card-foreground mb-2">{collection.name}</h3>
              <div className="flex justify-center items-center mb-4">
                <span className="text-sm text-muted-foreground">Supply: {collection.supply}</span>
              </div>
              <ul className="space-y-1 mb-6">
                {collection.features.map((feature, idx) => (
                  <li key={idx} className="text-sm text-muted-foreground">• {feature}</li>
                ))}
              </ul>
              <button className="w-full bg-primary text-primary-foreground py-2 px-4 rounded-lg hover:bg-primary/90 transition-colors">
                View Collection
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MnftsSection;
